import Image from "next/image";

export default function HeroImg({ isAr }: { isAr: boolean }) {
  return (
    <div
      className={`absolute top-0 bottom-0 ${isAr ? "left-0" : "right-0"} w-[46%] z-1`}
    >
      <Image
        src="/hero.png"
        alt="Real Estate Portal"
        fill
        priority
        className="object-center"
      />
      <div
        className={`absolute inset-0 bg-gradient-to-${isAr ? "left" : "right"} from-[#06080D]/10 via-[#06080D]/70 to-[#06080D]`}
      />

      <div className="absolute top-0 left-0 right-0 h-[30%] bg-linear-to-b from-[#06080D] to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-[30%] bg-linear-to-t from-[#06080D] to-transparent" />
    </div>
  );
}
